export default "__VITE_ASSET__BJRqCDa1__"